import script from "./Supporters.vue?vue&type=script&setup=true&lang=ts"
export * from "./Supporters.vue?vue&type=script&setup=true&lang=ts"

import "./Supporters.vue?vue&type=style&index=0&id=2a465f41&lang=scss"

const __exports__ = script;

export default __exports__